import { render } from "./wokerDetail19.vue?vue&type=template&id=1aee8e39&scoped=true"
import script from "./wokerDetail19.vue?vue&type=script&lang=js"
export * from "./wokerDetail19.vue?vue&type=script&lang=js"

import "./wokerDetail19.vue?vue&type=style&index=0&id=1aee8e39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aee8e39"]])

export default __exports__